import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import MasterProductService from "services/Setup/Master/masterService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  masterSecureTypeList: [{ code: "", name: "" }],
  masterTypeOfFinanceList: [{ code: "", name: "" }],
  masterNatureOfCreditList: [{ code: "", name: "" }],
  masterPartialPaymentOptList: {},
  masterLcCalcmethodList: {},
  eventTransactionList: {},
  currencyID: {},
};

export const getMasterSecureTypeList = createAsyncThunk(
  "masterProducts/getSecureType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterProductService.getMasterSecureType();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);
export const getMasterNatureOfCreditList = createAsyncThunk(
  "masterProducts/getMasterNatureOfCredit",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterProductService.getMasterNatureOfCredit();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);
export const getMasterTypeOfFinanceList = createAsyncThunk(
  "masterProducts/getMasterTypeOfFinance",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterProductService.getMasterTypeOfFinance();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getMasterPartialPymentOptList = createAsyncThunk(
  "masterProducts/getMasterPartialPymentOpt",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterProductService.getMasterPartialPymentOpt();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getMasterLcCalcmethodList = createAsyncThunk(
  "masterProducts/getMasterLcCalcmethod",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterProductService.getMasterLcCalcmethod();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getEventTransaction = createAsyncThunk(
  "masterProducts/getEventTransaction",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterProductService.getEventTransaction();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);
export const getCurrencyID = createAsyncThunk(
  "masterProducts/getCurrencyID",
  async (data, { rejectWithValue }) => {
    console.log("getCurrencyID start ---");
    try {
      const response = await MasterProductService.getCurrencyID();
      console.log("getCurrencyID response", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("getCurrencyID error", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const masterProduct = createSlice({
  name: "masterProduct",
  initialState,
  reducer: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get list secure type
      .addCase(getMasterSecureTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMasterSecureTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.masterSecureTypeList = action.payload;
      })
      .addCase(getMasterSecureTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list natureofcredit
      .addCase(getMasterNatureOfCreditList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMasterNatureOfCreditList.fulfilled, (state, action) => {
        state.loading = false;
        state.masterNatureOfCreditList = action.payload;
      })
      .addCase(getMasterNatureOfCreditList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list typeoffinance
      .addCase(getMasterTypeOfFinanceList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMasterTypeOfFinanceList.fulfilled, (state, action) => {
        state.loading = false;
        state.masterTypeOfFinanceList = action.payload;
      })
      .addCase(getMasterTypeOfFinanceList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list partialpaymentopt
      .addCase(getMasterPartialPymentOptList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMasterPartialPymentOptList.fulfilled, (state, action) => {
        state.loading = false;
        state.masterPartialPaymentOptList = action.payload;
      })
      .addCase(getMasterPartialPymentOptList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list lccalcmethod
      .addCase(getMasterLcCalcmethodList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMasterLcCalcmethodList.fulfilled, (state, action) => {
        state.loading = false;
        state.masterLcCalcmethodList = action.payload;
      })
      .addCase(getMasterLcCalcmethodList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list getCurrencyID
      .addCase(getCurrencyID.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCurrencyID.fulfilled, (state, action) => {
        console.log("getCurrencyID addCase", action.payload.data);
        state.loading = false;
        state.currencyID = action.payload.data;
      })
      .addCase(getCurrencyID.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get get Event Transaction
      .addCase(getEventTransaction.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getEventTransaction.fulfilled, (state, action) => {
        console.log("🚀 ~ .addCase ~ getEventTransaction:", action);
        state.loading = false;
        state.eventTransactionList = action.payload.data;
      })
      .addCase(getEventTransaction.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  masterProduct.actions;

export default masterProduct.reducer;
